import React from 'react'
import {style, media, merge} from 'glamor'

export default () => (
  <img
    src='/images/emoji.svg'
    {...merge(
      style({
        display: 'inline-block',
        marginLeft: '0.25rem'
      }),
      media('(min-width:800px)', {
        width: '26px'
      })
    )}
  />
)



/** WEBPACK FOOTER **
 ** ./src/components/Emoji.js
 **/